mutation VerifyMfa($code: String!) {
  verifyMfa(input: { code: $code }) {
    success
    errors
  }
}
